import { authService } from '../services/authService';

export const apiClient = {
  async get(url: string) {
    const token = authService.getAuthToken();
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Token ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('API request failed');
    }

    return response.json();
  },

  async post(url: string, data: any) {
    const token = authService.getAuthToken();
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Authorization': `Token ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error('API request failed');
    }

    return response.json();
  },

  async put(url: string, data: any) {
    const token = authService.getAuthToken();
    const response = await fetch(url, {
      method: 'PUT',
      headers: {
        'Authorization': `Token ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error('API request failed');
    }

    return response.json();
  },
};
